<script>
  /**
   * @type {string}
   */
  export let color = "#1C1C20";
  export let backgroundColor = "#F2F2F2";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M12.0043 20.6998C10.8015 20.6998 9.67038 20.4716 8.61105 20.0151C7.55172 19.5586 6.6303 18.939 5.8468 18.1563C5.06313 17.3736 4.4428 16.4534 3.9858 15.3956C3.52863 14.3376 3.30005 13.2071 3.30005 12.0041C3.30005 10.8012 3.5283 9.67014 3.9848 8.61081C4.4413 7.55147 5.06088 6.63005 5.84355 5.84655C6.62622 5.06289 7.54647 4.44255 8.6043 3.98555C9.6623 3.52839 10.7928 3.2998 11.9958 3.2998C13.1986 3.2998 14.3297 3.52806 15.389 3.98456C16.4484 4.44106 17.3698 5.06064 18.1533 5.8433C18.937 6.62597 19.5573 7.54622 20.0143 8.60405C20.4715 9.66205 20.7 10.7926 20.7 11.9956C20.7 13.1984 20.4718 14.3295 20.0153 15.3888C19.5588 16.4481 18.9392 17.3696 18.1565 18.1531C17.3739 18.9367 16.4536 19.5571 15.3958 20.0141C14.3378 20.4712 13.2073 20.6998 12.0043 20.6998Z"
    fill={backgroundColor}
    fill-opacity="0.5"
  />
  <path
    d="M11.9954 3.7998C13.1331 3.7998 14.1975 4.01494 15.1917 4.44336C16.1953 4.8759 17.0632 5.46117 17.8 6.19727C18.5371 6.93342 19.122 7.80062 19.5549 8.80273C19.9838 9.7952 20.2004 10.8575 20.2004 11.9951C20.2004 13.1329 19.9843 14.1972 19.5559 15.1914C19.1234 16.195 18.539 17.063 17.803 17.7998C17.0668 18.5369 16.1996 19.1217 15.1975 19.5547C14.2049 19.9836 13.142 20.2002 12.0042 20.2002C10.8665 20.2002 9.80296 19.9841 8.80884 19.5557C7.80524 19.1232 6.9373 18.5388 6.20044 17.8027C5.46331 17.0665 4.87754 16.1994 4.44458 15.1973C4.01567 14.2046 3.80005 13.1417 3.80005 12.0039C3.80007 10.8662 4.01522 9.8027 4.4436 8.80859C4.87615 7.80485 5.46136 6.93713 6.19751 6.2002C6.9337 5.46307 7.8008 4.87729 8.80298 4.44434C9.79539 4.01557 10.8578 3.79986 11.9954 3.7998Z"
    stroke={color}
    stroke-opacity="0.5"
  />
  <g transform="translate(5, 5) scale(1.0)">
    <path
      d="M3.73332 10.5586L3.44165 10.2669L6.70832 7.00023L3.44165 3.73356L3.73332 3.44189L6.99998 6.70856L10.2667 3.44189L10.5583 3.73356L7.29165 7.00023L10.5583 10.2669L10.2667 10.5586L6.99998 7.29189L3.73332 10.5586Z"
      fill={color}
      fill-opacity="0.5"
    />
  </g>
</svg>
